import { CloudAccountType } from '../types';

export const isAccountIdValid = (id: string, accountType: CloudAccountType) => {
  switch (accountType) {
    case CloudAccountType.AWS: {
      const regex = /\d{12}/;
      return regex.test(id);
    }
    case CloudAccountType.AZURE: {
      return true;
    }
    default: {
      return false;
    }
  }
};
